/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * 2026-10-16 라이브 검색어 끝 '*' 제거 (LOTUFF JAPAN)
 * Prestige 4.8.2 라이브 검색(theme.min.js)은 검색어 끝에 '*' 를 붙여 /search?view=ajax&q=<입력>*&type=... 로 요청한다.
 * 현재 Shopify 검색은 '*' 가 붙으면 정확 일치 대신 비슷한 상품을 대량으로 돌려준다 (3424 → 2건, 3424* → 83~86건).
 * 끝 단어 부분일치는 Shopify 기본 동작(prefix=last)이라 '*' 를 떼도 유지된다 (342 → LO-3424 2건).
 * → 라이브 검색(view=ajax) 요청의 q 값 끝 '*' 만 떼고 보낸다. 다른 fetch(장바구니 등)는 건드리지 않는다.
 * 되돌리기: 이 블록 삭제.
 */
(function () {
  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function' || nativeFetch.__lotuffSearchStarFix) return;

  var patchedFetch = function (input, init) {
    if (typeof input === 'string' && /\/search\?/.test(input) && /[?&]view=ajax(&|$)/.test(input)) {
      input = input.replace(/([?&]q=[^&]*?)\*+(?=&|$)/, '$1');
    }
    return nativeFetch.call(window, input, init);
  };
  patchedFetch.__lotuffSearchStarFix = true;
  window.fetch = patchedFetch;
})();

/**
 * 2026-10-16 상품 페이지 추가 옵션 (LOTUFF JAPAN) — GA Product Addons Gift Wrap(GoodApps) 앱 대체
 * 카드 마크업 = snippets/product-addons.liquid, 옵션 목록 = 컬렉션 product-addons.
 * - 「カートに追加」: 옵션을 골랐으면 옵션을 먼저 장바구니에 담고, 그다음 테마 기본 동작(본상품 담기 + 장바구니 서랍 열기)을 그대로 진행한다.
 *   먼저 담아야 서랍이 열릴 때 옵션까지 한 번에 보인다(나중에 담으면 서랍이 옛 내용으로 열릴 수 있음).
 * - 「今すぐ購入」: 옵션을 골랐으면 본상품+옵션을 장바구니에 담고 결제 화면으로 이동한다(장바구니에 있던 상품도 함께 결제됨).
 *   옵션을 안 골랐으면 두 버튼 모두 원래 동작 그대로.
 * - 옵션 줄에는 「対象商品: 본상품명」 속성을 붙여 어느 상품용인지 주문서에서 보이게 한다.
 * 되돌리기: 이 블록 삭제 (+ product-form.liquid 의 render 1줄).
 */
(function () {
  var ADD_URL = ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js';

  function addonRoot(el) {
    var section = el && el.closest ? el.closest('[data-section-type="product"]') : null;
    return section ? section.querySelector('[data-product-addons]') : null;
  }

  function checkedInputs(root) {
    return root ? Array.prototype.slice.call(root.querySelectorAll('.ProductAddons__Input:checked')) : [];
  }

  function addonItems(root, inputs) {
    var mainTitle = root.getAttribute('data-product-title') || '';
    return inputs.map(function (input) {
      return { id: parseInt(input.value, 10), quantity: 1, properties: { '対象商品': mainTitle } };
    });
  }

  function addToCart(items) {
    return fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) { throw new Error('cart add failed: ' + response.status); }
      return response.json();
    });
  }

  function clearInputs(inputs) {
    inputs.forEach(function (input) { input.checked = false; });
  }

  // 1) カートに追加
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-action="add-to-cart"]') : null;
    if (!button) { return; }
    if (button.getAttribute('data-addons-done') === '1') { button.removeAttribute('data-addons-done'); return; }

    var root = addonRoot(button);
    var inputs = checkedInputs(root);
    if (!inputs.length) { return; }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.getAttribute('data-addons-busy') === '1') { return; }
    button.setAttribute('data-addons-busy', '1');

    var proceed = function () {
      button.removeAttribute('data-addons-busy');
      clearInputs(inputs);
      button.setAttribute('data-addons-done', '1');
      button.click();
    };

    addToCart(addonItems(root, inputs)).then(proceed, proceed);
  }, true);

  // 2) 今すぐ購入
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('.shopify-payment-button__button') : null;
    if (!button) { return; }

    var form = button.closest('form[action*="/cart/add"]');
    var root = addonRoot(button);
    var inputs = checkedInputs(root);
    if (!form || !inputs.length) { return; }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.getAttribute('data-addons-busy') === '1') { return; }

    var idInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    if (!idInput || !idInput.value) { return; }
    button.setAttribute('data-addons-busy', '1');

    var quantity = Math.max(parseInt(quantityInput ? quantityInput.value : '1', 10) || 1, 1);
    var items = [{ id: parseInt(idInput.value, 10), quantity: quantity }].concat(addonItems(root, inputs));

    addToCart(items).then(function () {
      window.location.href = '/checkout';
    }, function () {
      button.removeAttribute('data-addons-busy');
      window.location.href = (window.routes && window.routes.cartUrl) || '/cart';
    });
  }, true);
})();
